export default __webpack_public_path__ + "static/media/empty.c3b2a378.jpg";